export default __webpack_public_path__ + "static/media/mo-img-team-advisros-sb3x.835bff64.png";